/** Padded surfaces: a 2px border 1px inside the box, so the box never grows. */
export const MESSAGE_INSET_FOCUS_BORDER_CLASS =
  "relative focus-visible:outline-none focus-visible:after:pointer-events-none focus-visible:after:absolute focus-visible:after:inset-px focus-visible:after:rounded-[inherit] focus-visible:after:border-2 focus-visible:after:border-[var(--focus-border)] focus-visible:after:content-['']";

/** Selected messages: the accent border stays 1px inside the clipped row. */
export const MESSAGE_SELECTED_BORDER_CLASS =
  "relative rounded-lg after:pointer-events-none after:absolute after:inset-px after:rounded-[7px] after:border-2 after:border-[var(--focus-border)] after:content-['']";

/** Unpadded text: a 2px outline 1px outside the box; needs 3px of unclipped room. */
export const MESSAGE_OUTSET_FOCUS_BORDER_CLASS =
  "outline outline-0 outline-offset-1 outline-transparent focus-visible:outline-2 focus-visible:outline-[var(--focus-border)]";

/**
 * The transcript row clips at its box (content-visibility), so it widens by
 * 3px on each side, never vertically, to give edge-flush borders room.
 */
export const TRANSCRIPT_ROW_INSET_CLASS = "-mx-[3px] px-[3px]";

/** A whole row's content: inside the box vertically, in the row's 3px inset horizontally. */
export const MESSAGE_ROW_FOCUS_BORDER_CLASS =
  "after:pointer-events-none after:absolute after:-inset-x-[3px] after:inset-y-0 after:rounded-lg after:border-2 after:border-[var(--focus-border)] after:content-['']";
